// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G7xr9QUwiHF4Yr2XFCwv {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;
    margin-top: 16px;
    flex-wrap: wrap;
}

.vfKS_E0ThgFzDf3azT8n {
    display: flex;
    align-items: center;
    gap: 8px;
}

.tyaiTIMi3iBMWOq7oaK0 {
    height: 12px;
    width: 12px;
    border-radius: 2px;
}

.PikoxyZ9y56yeHmz_usw {
    margin-left: auto !important;
    color: #666 !important;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Shared/AvailabilityShared/CalendarHeader/CalendarLegend/CalendarLegend.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B","sourcesContent":[".wrapper {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    margin-bottom: 16px;\n    margin-top: 16px;\n    flex-wrap: wrap;\n}\n\n.legendItem {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.legendBox {\n    height: 12px;\n    width: 12px;\n    border-radius: 2px;\n}\n\n.timezoneText {\n    margin-left: auto !important;\n    color: #666 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `G7xr9QUwiHF4Yr2XFCwv`,
	"legendItem": `vfKS_E0ThgFzDf3azT8n`,
	"legendBox": `tyaiTIMi3iBMWOq7oaK0`,
	"timezoneText": `PikoxyZ9y56yeHmz_usw`
};
export default ___CSS_LOADER_EXPORT___;
